import * as React from 'react'

import { Button, Radio } from '@factorialco/deprecated-design-system'
import { FormikProps } from 'formik'
import { isEmpty } from 'lodash'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

import { useCompensationCycle } from 'modules/attendance/hooks/useCompensationCycle'
import {
  getCompensationPeriodDescription,
  getCompensationPeriods,
} from 'modules/attendance/lib/compensationPeriodUtils'
import { FormData } from 'modules/attendance/lib/forms/TimeBlocksSupplementForm'

export interface Props {
  form: FormikProps<FormData>
  onSubmit: () => void
  onCancel: () => void
}

const PayrollPeriod = ({ form, onSubmit, onCancel }: Props) => {
  const { cycleRecurrence } = useCompensationCycle()
  const compensationPeriods = getCompensationPeriods(cycleRecurrence)

  return (
    <Modal
      title={i18n.t('clock_in.sidepanel.compensation.modal.payroll_period.title')}
      description={i18n.t('clock_in.sidepanel.compensation.modal.payroll_period.description')}
      illustration="monety-bag"
      onSubmit={() => {
        form.handleSubmit()
        if (isEmpty(form.errors)) {
          onSubmit()
        }
      }}
      onClose={onCancel}
      footer={
        <>
          <Button onClick={onCancel} type="secondary">
            {i18n.t('common.cancel')}
          </Button>
          <Button submit>
            {i18n.t('time_tracking.modals.compensation.payroll.create.submit')}
          </Button>
        </>
      }
    >
      <Radio.Wrap>
        <Radio
          name={compensationPeriods.current.label}
          value={form.values.period}
          onChange={(value) => form.setFieldValue('period', value)}
          description={getCompensationPeriodDescription(true)}
          option={{
            label: compensationPeriods.current.label,
            value: 'current',
          }}
        />
      </Radio.Wrap>
      <Radio.Wrap>
        <Radio
          name={compensationPeriods.next.label}
          value={form.values.period}
          onChange={(value) => form.setFieldValue('period', value)}
          description={getCompensationPeriodDescription(false)}
          option={{
            label: compensationPeriods.next.label,
            value: 'next',
          }}
        />
      </Radio.Wrap>
    </Modal>
  )
}

export default PayrollPeriod
